module.exports = __webpack_public_path__ + "media/images/athletes/1896-6e56da0afc45fe95769487986f72243f.png";